function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }

import { Controller as BaseController } from '@hotwired/stimulus';
import { findAll } from '@fretadao/f-js-dom';

var _loadedEvent = /*#__PURE__*/_classPrivateFieldLooseKey("loadedEvent");

export default class _class extends BaseController {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, _loadedEvent, {
      value: _loadedEvent2
    });
  }

  connect() {
    this.toggleDuplicatesHandler = this.toggleDuplicates.bind(this);
    this.checkboxes().forEach(checkbox => {
      checkbox.addEventListener('change', this.toggleDuplicatesHandler);
    });
    this.syncInputHandler = this.syncInput.bind(this);
    this.inputs().forEach(input => {
      input.addEventListener('input', this.syncInputHandler);
    });
    document.dispatchEvent(_classPrivateFieldLooseBase(this, _loadedEvent)[_loadedEvent]());
  }

  disconnect() {
    this.checkboxes().forEach(checkbox => {
      checkbox.removeEventListener('change', this.toggleDuplicatesHandler);
    });
    this.inputs().forEach(input => {
      input.removeEventListener('change', this.syncInputHandler);
    });
  }

  toggleDuplicates(event) {
    const checkbox = event.currentTarget;
    this.checkboxes({
      id: checkbox.id,
      value: checkbox.value
    }).forEach(dup => {
      dup.checked = checkbox.checked;
    });
    this.element.dispatchEvent(new CustomEvent('checkboxesChanged', {
      bubbles: true
    }));
  }

  syncInput(event) {
    const input = event.currentTarget;
    this.inputs(input.id).forEach(dup => {
      dup.value = input.value;
    });
    this.element.dispatchEvent(new CustomEvent('inputsChanged', {
      bubbles: true
    }));
  }

  checkboxes() {
    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        id = _ref.id,
        value = _ref.value;

    let query = 'input[type=checkbox]';

    if (!!id) {
      query = `#${id}`;
    } else if (!!value) {
      query += `[value="${value}"]`;
    }

    return findAll(query, this.element);
  }

  inputs() {
    let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let query = 'input:not([type=checkbox])';

    if (!!id) {
      query = `#${id}`;
    }

    return findAll(query, this.element);
  }

}

function _loadedEvent2() {
  return new CustomEvent('f-components-table:loaded', {
    detail: {
      desktopTable: this.desktopTableTarget,
      mobileTable: this.mobileTableTarget
    }
  });
}

_class.targets = ['desktopTable', 'mobileTable'];